angular.module('westBerkshireEvents.filter').filter('ticketquantity', function() {
    return function(basketItems) {
        let quantity = 0;
        basketItems.forEach(item => {
            quantity += item.tickets.qty;
        });
        return quantity;
    }
});


// WEBPACK FOOTER //
// src/public/javascripts/filter/ticket_quantity.filter.js